import { render } from "./PromptModal.vue?vue&type=template&id=0484e720&scoped=true"
import script from "./PromptModal.vue?vue&type=script&setup=true&lang=js"
export * from "./PromptModal.vue?vue&type=script&setup=true&lang=js"

import "./PromptModal.vue?vue&type=style&index=0&id=0484e720&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0484e720"],['__file',"src/components/modals/PromptModal.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0484e720"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0484e720', __exports__)) {
    api.reload('0484e720', __exports__)
  }
  
  module.hot.accept("./PromptModal.vue?vue&type=template&id=0484e720&scoped=true", () => {
    api.rerender('0484e720', render)
  })

}


export default __exports__